"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Loader = _interopRequireDefault(require("@common/components/common/Loader"));
var _utils = require("@design/lib/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ReviewLoadingState(_ref) {
  var _ref$message = _ref.message,
    message = _ref$message === void 0 ? "Your file is being sent for review." : _ref$message,
    className = _ref.className;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _utils.cn)("flex flex-col items-center w-full", className),
    "data-sentry-component": "ReviewLoadingState",
    "data-sentry-source-file": "ReviewLoadingState.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
      "data-sentry-element": "Loader",
      "data-sentry-source-file": "ReviewLoadingState.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "text-center w-full",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: message
      })
    })]
  });
}
var _default = exports.default = ReviewLoadingState;